(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('.stav-pdp-redesign').forEach((product) => {
      if (product.dataset.galleryReady) return;
      product.dataset.galleryReady = 'true';
      const gallery = product.querySelector('media-gallery');
      if (!gallery) return;
      const update = () => {
        gallery.querySelectorAll('.thumbnail-slide .swiper-slide').forEach((slide, index) => {
          slide.setAttribute('role', 'button');
          slide.setAttribute('tabindex', '0');
          slide.setAttribute('aria-label', `${product.dataset.galleryLabel} ${index + 1}`);
          slide.setAttribute('aria-pressed', String(slide.classList.contains('swiper-slide-thumb-active')));
        });
        gallery.querySelectorAll('.zoom_light_box').forEach((button) => {
          button.setAttribute('aria-label', product.dataset.zoomLabel);
          button.setAttribute('type', 'button');
        });
      };
      gallery.addEventListener('keydown', (event) => {
        const slide = event.target.closest('.thumbnail-slide .swiper-slide');
        if (slide && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          const preview = gallery.querySelector('.swiper-wrapper-preview.swiper');
          const slides = Array.from(slide.parentElement.children);
          if (preview?.swiper) preview.swiper.slideTo(slides.indexOf(slide));
        }
      });
      new MutationObserver(update).observe(gallery, {subtree: true, childList: true, attributes: true, attributeFilter: ['class']});
      update();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
